import { createSlice, createAction } from "@reduxjs/toolkit";
import { Notification, NotificationQueryParams } from "../type";
import { RootState } from "store/store";

interface NotificationState {
	notifications: Notification[];
	notificationTotal: number;
}

const initialState: NotificationState = {
	notifications: [],
	notificationTotal: 0,
};

export const notificationSlice = createSlice({
	name: "notification",
	initialState,
	reducers: {
		setNotifications: (state, action) => {
			if(action.payload.isNewNotifications) {
				const oldNotifications = state.notifications.splice(0, 10);
				const newNotifications = action.payload.data.filter((item: Notification) => !oldNotifications.includes(item));
				state.notifications = [...newNotifications, ...state.notifications];
			} else {
				state.notifications = [...state.notifications, ...action.payload.data];
			}
		},
		setNotificationAsRead: (state, action) => {
			const notiIndex = state.notifications.findIndex(
				noti => noti.id === action.payload,
			);
			state.notifications[notiIndex].read = true;
		},
		setAllNotificationsAsRead: (state, action) => {
			state.notifications = state.notifications.map(noti => {
				noti.read = true;
				return noti;
			});
		},
		setTotalUnreadNotifications: (state, action) => {
			state.notificationTotal = action.payload;
		},
	},
});

export const selectNotifications = (state: RootState) =>
	state.notification.notifications;

export const selectTotalUnreadNotifications = (state: RootState) =>
	state.notification.notificationTotal;

export const {
	setNotifications,
	setNotificationAsRead,
	setAllNotificationsAsRead,
	setTotalUnreadNotifications,
} = notificationSlice.actions;

export interface GetNotificationPayload {
	query: NotificationQueryParams,
	isNewNotifications?: boolean,
	returnResult: (result: boolean) => void,
}

export const getNotificationsAsync = createAction(
	"notification/getNotificationsAsync",
	(payload?: GetNotificationPayload) => ({
		payload: payload || {},
	}),
);

export interface ReadNotificationPayload {
	id: string;
}

export const readNotificationAsync = createAction(
	"notifications/readNotificationAsync",
	(payload: ReadNotificationPayload) => ({
		payload,
	}),
);


export const readAllNotificationsAsync = createAction(
	"notifications/readAllNotificationsAsync",
	(payload: any) => ({
		payload,
	}),
);

export const getTotalUnreadNotificationsAsync = createAction(
	"notifications/getNumOfNotifications",
	(payload: any) => ({
		payload,
	}),
);

export default notificationSlice.reducer;
